import { AxisType, TypeSize } from '@entities/Filter';
import { ProductSpecCode } from '@entities/Product/module/types/productSchema';

export type MarkType = {
  id: number;
  name: string;
  code: string;
};

export type ModelType = {
  id: number;
  name: string;
  code: string;
  groupCode: string;
};

export type YearCurrentType = string;

export type ModificationType = {
  id: number;
  name: string;
  code: string;
  engineName?: string;
};

export type CarBodiesType = {
  name: string;
  rangeYear: string;
  yearB: number;
  yearF: number;
  infoImage: {
    imageUrl: string;
    color: string;
    x1: number;
    y1: number;
    x2: number;
    y2: number;
  };
};

export interface сommonTypes {
  Id: number;
  ModifId: number;
  Axis: AxisType;
  SlaveId: number | any;
  Type: TypeSize;
}

export interface disksType extends сommonTypes {
  Dia: number;
  Diameter: number;
  ET: number;
  PCDc: number;
  PCDd: number;
  Width: number;
}

export interface tyresType extends сommonTypes {
  Diameter: number;
  Height: number;
  Width: number;
}

export interface RecommendedSizeByModificationType {
  disks: disksType[];
  tyres: tyresType[];
}

export interface RecommendedDiametersType {
  tyresDiameters: number[];
  disksDiameters: number[];
}

export interface RecSize {
  id: number;
  type: TypeSize;
  axis: AxisType;
  slaveId: number;
}

export interface RecSizeTyre extends RecSize {
  width: string;
  height: string;
  diameter: string;
}

export interface RecSizeDisk extends RecSize {
  width: string;
  diameter: string;
  PCDc: string;
  PCDd: string;
  et: string;
  dia: string;
}

export type modificationInfoElement = {
  title: string;
  code: ProductSpecCode;
  value: string;
};

export type CarBatterySpecification = {
  width: number;
  height: number;
  length: number;
  continent: string;
  capacity: number;
  terminalType: string;
  terminalLocation: string;
  polarity: number;
};

export interface RecommendedSizesType {
  tyresSizes: RecSizeTyre[];
  disksSizes: RecSizeDisk[];
  modificationInfo: modificationInfoElement[];
}

export const NameAxis = {
  [AxisType.allAxes]: 'для всех осей',
  [AxisType.frontAxles]: 'передняя ось',
  [AxisType.rearAxles]: 'задняя ось',
};

export const TitleTypeRecSize = {
  [TypeSize.factory]: 'Заводская комплектация',
  [TypeSize.replacement]: 'Варианты замены',
  [TypeSize.tuning]: 'Варианты тюнинга',
};

export const sortArrayParams = [ProductSpecCode.DiskUnitedPcd, ProductSpecCode.DiskDia, ProductSpecCode.DiskMount, ProductSpecCode.DiskEt];
